class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      // check btn has attribute for engraving product
      if(this.hasAttribute("data-engraving-product")){
        let cartItems = this.closest('cart-drawer-items');
        if(document.body.classList.contains("template-cart")){
          // console.log("template cart");
          cartItems = document.querySelector('cart-items');
        }
        let timestamp = this.dataset.timestamp;
        // console.log("timestamp",timestamp,cartItems);
        let bundle = cartItems.querySelectorAll(`.cart-item[data-timestamp="${timestamp}"]`);
        // console.log("bundle",bundle);
        let updates = {};
        if(bundle.length){
          bundle.forEach(item => {
            // updates[item.dataset.variantId] = 0;
            updates[item.dataset.key] = 0;
          });
        }
        if(document.body.classList.contains("template-cart")){
          bundle = cartItems.querySelectorAll(`cart-remove-button[data-timestamp="${timestamp}"]`);
          if(bundle.length){
            bundle.forEach(item => {
              // updates[item.dataset.variantId] = 0;
              updates[item.closest(".cart-item").dataset.key] = 0;
            });
          }
        }
        let updateObj = { "updates": updates};
        // console.log("updateObj",updateObj);
        cartItems.updateMultipleQuantity(updateObj,this.dataset.index);

      }else{
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        // console.log("this.dataset.index",this.dataset.index);
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    // Call the addSepratedProduct function
    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
      this.onCartTotalUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    // console.log("onChange",event.target);
    // if engraving product found then update both product's qty

      let parentElement = event.target.closest('.cart-item');
      // console.log(parentElement);
      let dataVarId = parentElement.getAttribute('data-var-id');
      if (parentElement) {
        if (parentElement.classList.contains('name-plate')) {  
          // Get the parent element
          var random_number = Math.floor(new Date().valueOf() * Math.random());      
          // console.log(random_number);
          var data = {
            items: []
          };
          var mainproduct = {
            id: dataVarId,
            quantity: 1,
            properties: {
               _Custom_Timestamp: random_number
            }
          };    
          let customProperties = parentElement.querySelectorAll('.custom-properies');
            customProperties.forEach(function(property) {
            let propertyName = property.getAttribute('data-prop-name');
            let propertyValue = property.getAttribute('data-prop-val');
            mainproduct.properties[propertyName] = propertyValue;
          });
          data.items.push(mainproduct);
          this.addSepratedProduct(dataVarId,data);
        } else {
          if(event.target.hasAttribute("data-engraving-product")){
            let timestamp = event.target.dataset.timestamp;
            // console.log("timestamp",timestamp);
            let bundleItems = document.querySelectorAll(`.cart-item[data-timestamp="${timestamp}"]`);
            // console.log("bundleItems",bundleItems);
            let updates = {};
            if(bundleItems.length){
              bundleItems.forEach(item => {
                // updates[item.dataset.variantId] = 0;
                updates[item.dataset.key] = event.target.value;
              });
            }
            let updateObj = { "updates": updates};
            // console.log("updateObj",updateObj);
            this.updateMultipleQuantity(updateObj,event.target.dataset.index);
          }else{
            this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
          }
        }
      } 
    }

    addSepratedProduct(dataVarId,data) {
      // console.log(dataVarId);
      
      	  var self = this; // Store reference to 'this' context
          // Prepare the request body
          var body = JSON.stringify(data);
          // Define fetch options
          var options = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: body,
          };
          
      // Make the fetch request
      fetch('/cart/add.js', options)
          .then(function(response) {
              // Check if response is successful
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              // Parse the JSON response
              
              return response.json();
          })
          .then(function(line_item) {
            self.onCartUpdate();
            self.onCartTotalUpdate();
          })
          .catch(function(error) {
              // Handle errors
              console.error('Error:', error);
          });
        }
        onCartTotalUpdate(){
          fetch('/cart.js')
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              return response.json();
          })
          .then(cart => {
            document.querySelector('.cart-count-bubble').textContent = cart.item_count;
              fetch(`${routes.cart_url}?section_id=cart-total-live`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  var totals = $(html).find('.totals').html();
                  $('.totals').html(totals);
                })
                .catch((e) => {
                  console.error(e);
              });
          })
          .catch(error => {
              console.error('Error:', error);
          });
       }
    
  onCartUpdate() {

    if (this.tagName === 'CART-DRAWER-ITEMS') {
      
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer' , '.drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {

      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
      });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      }
      // {
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '.js-contents',
      // },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    // console.log("updateQuantity");
    this.enableLoading(line);

    let body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
   
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        // console.log("parsedState",parsedState);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          if(section.id == "main-cart-items"){
            // const elementToReplace = document.getElementById(`shopify-section-${section.section}`).querySelector(".main-cart-wrap");
            const elementToReplace = document.querySelector(`.section-main-cart-item`).querySelector(".main-cart-wrap");
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section],".main-cart-wrap");
          }else{
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section],section.selector);
          }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateMultipleQuantity(updateObj,line) {
    // console.log("updateMultipleQuantity");
    this.enableLoading(line);

    // add section for updated HTML
    updateObj.sections = this.getSectionsToRender().map((section) => section.section),
    updateObj.sections_url = window.location.pathname;
    // console.log("updateObj",updateObj);    
    
    fetch(routes.cart_update_url+'.js', {
      method: 'POST',
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(updateObj)
    })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      // console.log("parsedState",parsedState)
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

      this.getSectionsToRender().forEach((section) => {
        // console.log("section",section);
        if(section.id == "main-cart-items"){
          const elementToReplace = document.getElementById(`shopify-section-${section.section}`).querySelector(".main-cart-wrap");
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section],".main-cart-wrap");
        }else{
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section],section.selector);
        }
      });
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
    })
    .catch(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      this.disableLoading(line);
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
